import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import PDFIcon from "formassets/pdf.svg?react";
import XLSIcon from "formassets/xls.svg?react";
import OtherIcon from "formassets/other.svg?react";
import PngIcon from "formassets/png.svg?react";
import JpgIcon from "formassets//jpg.svg?react";
import DocIcon from "formassets/doc.svg?react";
import TXTIcon from "formassets/txt.svg?react";

const AttachmentIconComponent: FC<Props> = ({ file, className }) => {
  const name = file.split(".");
  const extenstion = name[name.length - 1];

  switch (extenstion) {
    case "jpg":
      return <JpgIcon className={`${styles.icon} ${className}`} />;
    case "xlsx":
      return <XLSIcon className={`${styles.icon} ${className}`} />;
    case "pdf":
      return <PDFIcon className={`${styles.icon} ${className}`} />;
    case "png":
      return <PngIcon className={`${styles.icon} ${className}`} />;
    case "doc":
      return <DocIcon className={`${styles.icon} ${className}`} />;
    case "docx":
      return <DocIcon className={`${styles.icon} ${className}`} />;
    case "txt":
      return <TXTIcon className={`${styles.icon} ${className}`} />;
    default:
      return <OtherIcon className={`${styles.icon} ${className}`} />;
  }
};

export default AttachmentIconComponent;
